// extracted by css-extract-rspack-plugin
export default {"errorContainer":"errorContainer-Z218BR","link":"link-VIwcqw"};